import { defineStore } from 'pinia';
import { ref } from 'vue';
import { fetchResultListTeaser } from '@/services/api/snippets/fetchResultListTeaser';
import { sanitizeSnippetHtml } from '@/utils/sanitizeSnippetHtml';

export const useResultListTeaserStore = defineStore('resultListTeaser', () => {
  const html = ref<string | null>(null);
  const loading = ref(false);
  const loaded = ref(false);

  async function fetchTeaser(): Promise<void> {
    if (loaded.value || loading.value) return;
    loading.value = true;
    try {
      const raw = await fetchResultListTeaser();
      html.value = sanitizeSnippetHtml(raw);
    } catch (err) {
      console.warn('[ResultListTeaser] failed to load snippet', err);
    } finally {
      loaded.value = true;
      loading.value = false;
    }
  }

  return { html, loading, loaded, fetchTeaser };
});
